export const stopPropagation = (e: { stopPropagation: () => void }) => {
  e.stopPropagation();
};
